import React, { Component } from 'react';
import axios from 'axios';


class AddProcedure extends Component {
  state = {
    title: '',
    description: '',
    parsedDescription: [],
    isActive: false,
    windowHeight: window.innerHeight - 60,
    error: null,
    loading: false, // Added loading state
  };
  fileInputRef = React.createRef();
  // for the image 







  


  // start of the handle submition


  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (name === 'description') {
        this.parseDescription(value);
      }
    });
  };

  parseDescription = (text) => {
    const lines = text.split('\n');
    const parsed = lines
      .filter((line) => line.trim().startsWith('#'))
      .map((line, index) => {
        const trimmedLine = line.trim().substring(1).trim(); // Remove leading '#' and spaces
        return {
          id: (index + 1).toString(), // Generate an ID
          paragraph: trimmedLine,
        };
      });
    this.setState({ parsedDescription: parsed });
  };

 
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    const formData = new FormData();
    formData.append('title', this.state.title);
    formData.append('description', this.state.description
    // JSON.stringify(this.state.parsedDescription)
      ); // Stringify the array

    try {
      const course_id = this.props.course_id
      const courseId = parseInt(course_id, 10);
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/step-by-step/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.setState({
        title: '',
        description: '',
        parseDescription: '',
      });
      if (this.props.onDocumentSubmit) {  // Check if the prop exists
        this.props.onDocumentSubmit(); // Call the callback to signal the parent
      }
    } catch (error) {
      console.error('Error submitting form:', error);

    }
    finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };


  // end for the submition





  // the display
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover.addsteps")
      formdisplay.style.display = "none"
    }

  };
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  render() {

    const { menuCoverWidth } = this.state;
    console.log("procedure in question",this.state)

    return (

      <div className="dash_add_course_cover addsteps" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Course Contents</h2>
          <p>Make sure to follow the instruction if any bellow the input </p>
          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label htmlFor="title">Title</label><br />
            <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="Input course title" /><br /><br />
            <label htmlFor="description">Describe the Course</label><br />
            <p className='info'>Before starting any paragraph use a '#' then the content what you want to write</p>
            <textarea name="description" id='description' value={this.state.description} onChange={this.handleInputChange} 
            placeholder="# i am going to school
            #1. buy mk a book " /><br /><br />
            
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Uploading..." : "Submit"}
            </button>
          </form>
        </div>
      </div>


    );
  }
}

export default AddProcedure;